<template>
  <div class="api-set">
    <div class="main">
      <p>API</p>
      <div class="content bg-white">
        <el-form ref="setForm" label-position="right" label-width="150px" :model="setForm">
          <el-form-item :label="$t('PersonalCenter.ApiSet.Token')" prop="token">
            <el-input v-model="setForm.token" disabled :type="setForm.token&&setForm.token.length>30 ? 'textarea' : 'text'" :rows="6" style="width: 500px;margin-right:10px;"></el-input>
            <el-button v-if="!(setForm.token&&setForm.token.length>30)" type="text" @click="show()">{{ $t('PersonalCenter.ApiSet.Check') }}</el-button>
          </el-form-item>
          <el-form-item :label="$t('PersonalCenter.ApiSet.MaturityTime')" prop="tokenExpireTime">
            <el-input v-model="setForm.time" disabled style="width: 500px;margin-right:10px;"></el-input>
            <el-button type="primary" @click="show('put')">{{ $t('PersonalCenter.ApiSet.RenewToken') }}</el-button>
          </el-form-item>
          <el-form-item :label="$t('PersonalCenter.ApiSet.APIDocument')" prop="tokenExpireTime">
            <el-button type="text" @click="jump">https://docs.kakaclo.com</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <web-hooks></web-hooks>
    <el-dialog
      :title="$t('PersonalCenter.ApiSet.hint1')"
      :visible.sync="dialogVisible"
      width="500px">
      <div class="f--c">
        <div style="width:80px">Password:</div>
        <el-input style="width:300px" v-model="password" type="password" :placeholder="$t('PersonalCenter.ApiSet.hint1')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('PersonalCenter.ApiSet.Cancel') }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{ $t('PersonalCenter.ApiSet.Confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import { dateFormat } from '@/util/date'
import { encrypt } from '@/util/encryp.js'
import webHooks from './components/webHooks.vue'
export default {
  components: { webHooks },
  data() {
    return {
      dialogVisible: false,
      setForm: {
        token: '**********',
        time: undefined,
        tokenExpireTime: ''
      },
      password: undefined,
      method: 'get'
    }
  },
  mounted() {
    this.getStoreDeveloperToken()
  },
  methods: {
    getStoreDeveloperToken(password) {
      if (password) {
        password = encrypt(password)
      }
      if (this.method !== 'get') {
        let now = new Date().getTime()
        now += (7 * 24 * 60 * 60 * 1000)
        console.log(now, this.setForm.tokenExpireTime)
        if (now - this.setForm.tokenExpireTime < 0) {
          return this.$message.warning(this.$t('PersonalCenter.ApiSet.hint2'))
        }
      }
      let apiUrl = this.method === 'get' ? 'getStoreDeveloperToken' : 'setStoreDeveloperToken'
      API[apiUrl]({ password }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$set(this.setForm, 'time', res.data.tokenExpireTime ? dateFormat(res.data.tokenExpireTime) : '')
        this.$set(this.setForm, 'tokenExpireTime', res.data.tokenExpireTime)
        this.$set(this.setForm, 'token', res.data.token || '**********')
      })
    },
    handleConfirm() {
      if (!this.password) {
        return this.$message.warning(this.$t('PersonalCenter.ApiSet.hint1'))
      }
      this.getStoreDeveloperToken(this.password)
      this.dialogVisible = false
      this.password = undefined
    },
    show(type) {
      this.method = type || 'get'
      this.dialogVisible = true
    },
    jump() {
      window.open('https://docs.kakaclo.com')
    }
  }
}
</script>

<style lang="scss" scoped>
.api-set {
  .main {
    >p {
      font-size: 18px;
      font-weight: bold;
      padding: 10px;
    }

    .content {
      padding: 30px;
    }
  }

}
/deep/.el-input__inner {
  border-radius: 2px !important;
}
</style>
